module.exports = "https://static.wanderu.com/ui-react/_next/static/media/hero-header.54ff18d4.svg";